var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFalkonSystemsIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.078,
    height: 22.83,
    viewBox: "0 0 16.078 22.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Falkon_SYSTEMS-01",
    "data-name": "Falkon SYSTEMS-01",
    transform: "translate(-174.125 -212.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M180.085,217.944a16.055,16.055,0,0,1-4.607-5.544,5.98,5.98,0,0,0-.746,2.048c-.074.655-.461,2.618,3.528,5.36,2.736,1.881,3.828,3.224,3.87,4.96-.812-3.251-7.492-4.918-7.923-7.411-.5,3.882,1.321,5.969,4.876,8.029,4.526,2.622-.8,7.46-4.92,9.844,5.314-2.343,7.953-4.479,9.454-7.477C185.19,224.608,184.493,221.035,180.085,217.944Z",
    transform: "translate(0)",
    fill: "#647084"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M590.181,603.716c-1.7-.45-2.817.236-4.319.666a6.8,6.8,0,0,1-.189,8.736,11.251,11.251,0,0,1-2.173,2.571h0c3.541-2.34,5.4-7.118,5.4-7.118l.061-.187c1.321-3.718,3.708-2.534,3.71-2.534A3.485,3.485,0,0,0,590.181,603.716Z",
    transform: "translate(-402.469 -384.569)",
    fill: "#647084"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFalkonSystemsIcon);
export default __webpack_public_path__ + "static/media/falkon-systems-icon.c732c9cf06b8f019ac110eb65f99a7f5.svg";
export { ForwardRef as ReactComponent };